import { action, makeObservable, observable } from "mobx";
import { IDueDate, sortDueDates } from "../config/due_date";
import { optimizeFuturePayments } from "../helpers/due_date_helpers";
import { fetchGet } from "../services/api";

export class DueDateStore {
    @observable dueDates: IDueDate[] = [];
    @observable shouldBePopulated: boolean = true;

    constructor() {
        makeObservable(this);
    }

    @action
    load(dueDates: IDueDate[]) {
        this.dueDates = dueDates;
        this.shouldBePopulated = false;
    }
}

export const fetchFuturePayments = (): Promise<IDueDate[]> => {
    return fetchGet('/duedates')
        .then(response => response.json())
        .then(data => {
            return sortDueDates((data.data || []).map(optimizeFuturePayments));
        });
};
